import { gql } from "@apollo/client";

import { addAuthVars } from "@teamrota/authlib";

export default addAuthVars(gql`
  query fetchMemberTimesheets(
    $memberId: ID!
    $limit: Int!
    $offset: Int!
    $startBefore: Date
    $startAfter: Date
    $orderByColumn: String
    $orderByDirection: String
  ) {
    memberTimesheets(
      memberId: $memberId
      limit: $limit
      offset: $offset
      startBefore: $startBefore
      startAfter: $startAfter
      orderByColumn: $orderByColumn
      orderByDirection: $orderByDirection
    ) {
      data {
        id
        scheduledStartTime
        scheduledEndTime
        status
        approvedAt
        checkInTime
        checkOutTime
        totalMinutes
        breakMinutes
        memberId
        timesheetId
        venueId
        subvenueId
        roleName
        name
        accountName
        venueName
        bookingId
        shiftId
        sourceAccountId
      }
      totalResults
      offset
      limit
    }
  }
`);
